module.exports = __webpack_public_path__ + "static/media/README.366f8e4d.md";